import "./MessageAttachments.scss";
import { ImageCore, Label } from 'src/ui';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import Visage2Icon from 'src/visage2/Visage2Icon/Visage2Icon';
import ComposerAttachmentFile from '../ComposerAttachmentFile/ComposerAttachmentFile';
import { SpintrTypes } from 'src/typings';
import { localize } from 'src/l10n';
import VideoJSPlayer from 'src/components/VideoJSPlayer/VideoJSPlayer';
import { Stack } from "@fluentui/react";

interface IProps {
    message: Spintr.IChatMessage;
    isParent?: boolean;
}

const imageFileTypes = [SpintrTypes.FileType.Png, SpintrTypes.FileType.Jpg, SpintrTypes.FileType.Gif];
const audioFileTypes = [SpintrTypes.FileType.Aac, SpintrTypes.FileType.Mp3, SpintrTypes.FileType.M4a, SpintrTypes.FileType.Webm];
const videoFileTypes = [SpintrTypes.FileType.Mp4];

const MessageAttachments = (props: IProps) => {
    if (!props.message.attachments || props.message.attachments.length === 0) {
        return null;
    }

    return (
        <div className={"MessageAttachments"}>
            {props.message.attachments.map((attachment: Spintr.IChatMessageAttachment) => {
                if (imageFileTypes.indexOf(attachment.typeId) > -1) {
                    return (
                        <ImageCore
                            key={attachment.id}
                            openPhotoBoxOnClick
                            imageInChat={true}
                            imageId={attachment.id}
                            alt={attachment.name}
                            //@ts-ignore
                            src={attachment.thumbnailUrl || attachment.path}
                            title={attachment.name}
                        />
                    )
                }

                if (videoFileTypes.includes(attachment.typeId)) {
                    if (props.isParent) {
                        return (
                            <Stack horizontal tokens={{ childrenGap: 4 }} key={attachment.id}>
                                <Visage2Icon icon="video" />
                                <Label>{localize("ATTACHED_VIDEO")}</Label>
                            </Stack>
                        );
                    }

                    return (
                        <div className="video-attachment" key={attachment.id}>
                            <VideoJSPlayer videoUrl={attachment.path} uberId={attachment.id} />
                        </div>
                    );
                }

                if (audioFileTypes.includes(attachment.typeId)) {
                    return (
                        <AudioPlayer
                            url={attachment.path}
                            key={attachment.id} />
                    )
                }

                return (
                    <a className="file-attachment" key={attachment.id} href={`/api/v1/servefile/${attachment.id}`} target="_blank" rel="noreferrer">
                        <ComposerAttachmentFile attachment={attachment} />
                    </a>
                )
            })}
        </div>
    )
}

export default MessageAttachments;
